export enum FlowStepSequenceType {
    STANDARD = "standard",
    PATH_CANDIDATE = "path_candidate",
    BRANCH_MERGE = "branch_merge",
    ITERATE = "iterate",
    ITERATE_PARALLEL = "iterate_parallel",
    ITERATE_WHILE = "iterate_while",
}
